import React, { Fragment, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';
import { headerLogoConfig } from '../configs/headerLogoConfigs';

const Logo = ({
    logoUrlLink,
    dashboardUrlLink,
    logo,
    logoMobile,
    stateCode,
    name,
    carrierLogoUrl,
    logoUrlMobile,
    micrositeIds,
    hasUser,
    isAnonymous,
}) => {
    const intl = useIntl();
    const logoConfig = stateCode ? headerLogoConfig[stateCode] : {};
    const { exchangeName } = useAppSelector(environmentSelector);

    const redirectToDashboardIfLoggedIn = logoConfig?.redirectToDashboardIfLoggedIn;

    const logoUrlRedirect = useMemo(() => {
        if (redirectToDashboardIfLoggedIn && !isAnonymous && hasUser) {
            return dashboardUrlLink;
        }

        return logoUrlLink;
    }, [isAnonymous, hasUser, logoUrlLink, dashboardUrlLink, redirectToDashboardIfLoggedIn]);

    const openInCurrentTab = useMemo(() => {
        if (redirectToDashboardIfLoggedIn && !isAnonymous) {
            return true;
        }

        return false;
    }, [redirectToDashboardIfLoggedIn, isAnonymous]);

    function getLogoImg() {
        return (
            <Fragment>
                {micrositeIds && (
                    <Fragment>
                        <img
                            id="masthead__carrier__logo__img"
                            className="gi-masthead__logo__img gi-masthead__logo__img--carrier"
                            src={carrierLogoUrl}
                            alt={name}
                        />
                        <img
                            id="masthead__carrier__logo__img__mobile"
                            className="gi-masthead__logo__img__mobile gi-masthead__logo__img__mobile--carrier"
                            src={logoUrlMobile}
                            alt={name}
                        />
                    </Fragment>
                )}

                <img
                    id="masthead__logo__img"
                    className="gi-masthead__logo__img"
                    src={logo}
                    alt={intl.formatMessage({ id: 'header.logo.alt' })}
                />
                <img
                    id="masthead__logo__img__mobile"
                    className="gi-masthead__logo__img__mobile"
                    src={logoMobile}
                    alt={intl.formatMessage({ id: 'header.logo.alt' })}
                />
            </Fragment>
        );
    }
    return (
        <Fragment>
            <div className="usa-logo gi-masthead__logo" id="gi-masthead-logo-wrap">
                <div className="grid-row">
                    {logoConfig.link && (
                        <div className="masthead_logo">
                            <a
                                href={logoUrlRedirect}
                                target={openInCurrentTab ? '_self' : '_blank'} // Defaults to '_blank' unless explicitly false
                                rel={openInCurrentTab ? undefined : 'noopener noreferrer'} // Add 'rel' only for '_blank'
                                data-automation-id="masthead__logo__url"
                                title={intl.formatMessage({
                                    id: openInCurrentTab ? exchangeName : 'header.logo.link.title',
                                })}
                            >
                                {getLogoImg()}
                            </a>
                        </div>
                    )}
                    {!logoConfig.link && getLogoImg()}
                    {logoConfig.tagline && (
                        <div className="tagline">
                            <FormattedMessage
                                id="header.logo.tagline"
                                values={{
                                    registeredTrademarkSymbol: <sup>&#174;</sup>,
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
            <button className="usa-menu-btn gi-masthead__nav__btn--collapse">
                {/*<FontAwesomeIcon icon="bars" />*/}
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="sr-only">Options</span>
            </button>
        </Fragment>
    );
};

export default Logo;
